class Megamenu {
  constructor(container) {
    container._slimlineMegamenu?.destroy();
    this.events = new AbortController();
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-menu-button",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop",
    };
    this.menuSelectors = {
      subMenu: ".m-mega-menu",
    };
    this.activeDesktopMenuItem = null;

    this.sliders = {};
    this.open = false;
    this.container = container;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors, container);
    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => {
      const header = item.closest("header");
      const menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: false };
    });
    this.init();
    container._slimlineMegamenu = this;

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    const options = { signal: this.events.signal };
    this.domNodes.hamburgerButtons.addEventListener("click", (e) => {
      this.open ? this.closeMenu() : this.openMenu();
    }, options);
    this.domNodes.backDrop.addEventListener("click", (e) => {
      this.closeMenu();
    }, options);
    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu(false);
    });
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu(false);
    });
  }
  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { item, subMenu } = menuItem;
      if (subMenu) {
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        if (productsBanner) {
          if (window && window.__sfWindowLoaded) {
            menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
          } else {
            window.addEventListener("load", () => {
              menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
            }, { signal: this.events.signal, once: true });
          }
        }
      }
    });
  }
  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex];
    const { header } = menuItem;
    header && header.classList.remove("show-menu");
  };
  initProductsBanner(banner) {
    const header = banner.closest("header");
    const menuItem = banner.closest(".m-menu__item");
    const screenClass = (header && `.${header.dataset.screen}`) || "";

    const id = banner.dataset.id;
    const sliderContainer = document.querySelector(`.m-product-list-${id}`);
    const columns = sliderContainer.dataset.column;

    let slider;
    slider = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns },
      },
    });
    this.sliders[menuItem.dataset.index] = slider;

    if (slider) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);
      prevBtn && prevBtn.addEventListener("click", () => slider.slidePrev());
      nextBtn && nextBtn.addEventListener("click", () => slider.slideNext());
    }
  }

  initMobileMegaMenu() {
    const options = { signal: this.events.signal };
    const { menuDrawer, hamburgerButtons } = this.domNodes;
    menuDrawer.inert = true;
    menuDrawer.setAttribute("aria-hidden", "true");
    hamburgerButtons.setAttribute("aria-expanded", "false");
    this.domNodes.megaMenuMobile.forEach((panel) => this.syncMobilePanel(panel, false));
    // One scoped handler avoids the old nested delegation opening a make's
    // model panel and its ancestor menu from the same tap.
    menuDrawer.addEventListener("click", (event) => {
      const close = event.target.closest(".slimline-mobile-menu-close");
      if (close) return this.closeMenu();
      const back = event.target.closest(".m-menu-mobile__back-button");
      if (back) {
        event.preventDefault();
        return this.closeSubMenu(back.closest(".m-megamenu-mobile"), back.dataset.level);
      }
      const alphabetLink = event.target.closest(".slimline-make-index__link");
      if (alphabetLink) {
        event.preventDefault();
        return this.jumpToMobileMake(alphabetLink);
      }
      const toggle = event.target.closest("[data-toggle-submenu]");
      if (toggle) {
        const item = toggle.closest(".m-menu-mobile__item");
        const panel = item?.querySelector(":scope > .m-megamenu-mobile");
        if (panel) {
          event.preventDefault();
          this.openSubMenu(panel, toggle.dataset.toggleSubmenu);
        }
      } else if (event.target.closest("a[href]")) {
        this.closeMenu(false);
      }
    }, options);
    document.addEventListener("keydown", (event) => {
      if (!this.open) return;
      const panel = this.activeMobilePanel();
      if (event.key === "Escape") {
        event.preventDefault();
        panel ? this.closeSubMenu(panel, panel.classList.contains("m-megamenu-mobile--level-2") ? "2" : "1") : this.closeMenu();
      } else if (event.key === "Tab") {
        const scope = panel || this.domNodes.menuDrawerContent;
        const controls = [hamburgerButtons, this.domNodes.menuDrawer.querySelector(".slimline-mobile-menu-close"), ...scope.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]')]
          .filter(Boolean)
          .filter((node) => node.tabIndex >= 0 && !node.closest("[inert]") && node.getClientRects().length && getComputedStyle(node).visibility !== "hidden");
        if (!controls.length) return;
        // Traverse the allowed controls explicitly: native DOM order also
        // includes logo/cart links and the covered parent menu underneath.
        event.preventDefault();
        const current = controls.indexOf(document.activeElement);
        const next = current < 0 ? (event.shiftKey ? controls.length - 1 : 0)
          : (current + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
        controls[next].focus();
      }
    }, options);
    const resize = () => {
      if (window.innerWidth >= 1024 && this.open) this.closeMenu(false);
      else if (this.open) this.setMenuHeight();
    };
    window.addEventListener("resize", resize, options);
    window.visualViewport?.addEventListener("resize", resize, options);
    document.addEventListener("matchMobile", resize, options);
    document.addEventListener("unmatchMobile", resize, options);
  }

  //////////////// MOBILE MENU EVENTS
  openMenu() {
    if (window.innerWidth >= 1024) return;
    this.setMenuHeight();
    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");
    this.domNodes.headerMobile.classList.add("header-drawer-open");
    this.domNodes.menuDrawer.inert = false;
    this.domNodes.menuDrawer.setAttribute("aria-hidden", "false");
    this.domNodes.hamburgerButtons.classList.add("active");
    this.domNodes.hamburgerButtons.querySelector(".m-hamburger-box")?.classList.add("active");
    this.domNodes.hamburgerButtons.setAttribute("aria-expanded", "true");
    this.domNodes.hamburgerButtons.setAttribute("aria-label", "Close menu");
    this.open = true;
    requestAnimationFrame(() => {
      if (this.open) this.domNodes.menuDrawerContent.querySelector("button, a[href]")?.focus({ preventScroll: true });
    });
  }

  closeMenu(returnFocus = true) {
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons } = this.domNodes;

      megaMenuMobile.forEach((container) => this.syncMobilePanel(container, false));
      this.domNodes.menuDrawerContent.classList.remove("open-submenu");
      menuDrawer.querySelectorAll(".m-megamenu-mobile__wrapper.open-submenu").forEach((wrapper) => wrapper.classList.remove("open-submenu"));
      menu && menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
      menuDrawer.classList.remove("open");
      document.documentElement.classList.remove("prevent-scroll");
      this.domNodes.headerMobile.classList.remove("header-drawer-open");
      hamburgerButtons.classList.remove("active");
      hamburgerButtons.querySelector(".m-hamburger-box")?.classList.remove("active");
      hamburgerButtons.setAttribute("aria-expanded", "false");
      hamburgerButtons.setAttribute("aria-label", "Open menu");
      menuDrawer.setAttribute("aria-hidden", "true");
      menuDrawer.inert = true;
    this.open = false;
    if (returnFocus) hamburgerButtons.focus({ preventScroll: true });
  }

  openSubMenu(subMenuContainer, level) {
    if (!subMenuContainer) return;
    this.domNodes.megaMenuMobile.forEach((panel) => {
      if (level === "1" || panel.classList.contains("m-megamenu-mobile--level-2")) this.syncMobilePanel(panel, false);
    });
    if (level === "1") {
      this.domNodes.menu.classList.remove("m-submenu-open--level-2");
      this.domNodes.menuDrawer.querySelectorAll(".m-megamenu-mobile__wrapper.open-submenu").forEach((wrapper) => wrapper.classList.remove("open-submenu"));
    } else {
      subMenuContainer.closest(".m-megamenu-mobile--level-1")?.querySelector(":scope > .m-megamenu-mobile__wrapper")?.classList.add("open-submenu");
    }
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu && this.domNodes.menu.classList.add("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.add(subMenuOpenClass);
    this.syncMobilePanel(subMenuContainer, true);
    subMenuContainer.querySelector(":scope > .m-megamenu-mobile__wrapper").scrollTop = 0;
    subMenuContainer.querySelectorAll(".slimline-make-index__link").forEach((link) => link.removeAttribute("aria-current"));
    requestAnimationFrame(() => {
      if (subMenuContainer.classList.contains("open")) subMenuContainer.querySelector(".m-menu-mobile__back-button")?.focus({ preventScroll: true });
    });
  }

  closeSubMenu(subMenuContainer, level) {
    if (!subMenuContainer) return;
    const trigger = subMenuContainer.parentElement.querySelector(":scope > button[data-toggle-submenu], :scope > [data-toggle-submenu]");
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    level === "1" && this.domNodes.menu && this.domNodes.menu.classList.remove("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.remove(subMenuOpenClass);
    this.syncMobilePanel(subMenuContainer, false);
    if (level === "1") {
      this.domNodes.megaMenuMobile.forEach((panel) => this.syncMobilePanel(panel, false));
      this.domNodes.menu.classList.remove("m-submenu-open--level-2");
      this.domNodes.menuDrawerContent.classList.remove("open-submenu");
    }
    this.domNodes.menuDrawer.querySelectorAll(".m-megamenu-mobile__wrapper.open-submenu").forEach((wrapper) => wrapper.classList.remove("open-submenu"));
    trigger?.focus({ preventScroll: true });
  }

  syncMobilePanel(panel, open) {
    panel.classList.toggle("open", open);
    panel.inert = !open;
    panel.setAttribute("aria-hidden", String(!open));
    panel.parentElement.querySelectorAll(":scope > [data-toggle-submenu]").forEach((toggle) => {
      toggle.setAttribute("aria-expanded", String(open));
      if (panel.id) toggle.setAttribute("aria-controls", panel.id);
    });
  }

  activeMobilePanel() {
    return this.domNodes.menuDrawer.querySelector(".m-megamenu-mobile--level-2.open")
      || this.domNodes.menuDrawer.querySelector(".m-megamenu-mobile--level-1.open");
  }

  jumpToMobileMake(link) {
    const wrapper = link.closest(".m-megamenu-mobile__wrapper");
    const target = document.getElementById(link.hash.slice(1));
    if (!wrapper || !target || !wrapper.contains(target)) return;
    const heading = wrapper.querySelector(".slimline-mobile-menu-heading");
    const top = wrapper.scrollTop + target.getBoundingClientRect().top - wrapper.getBoundingClientRect().top
      - (heading?.offsetHeight || 0) - 8;
    wrapper.scrollTo({ top: Math.max(0, top), behavior: "instant" });
    wrapper.querySelectorAll(".slimline-make-index__link").forEach((indexLink) => {
      if (indexLink === link) indexLink.setAttribute("aria-current", "location");
      else indexLink.removeAttribute("aria-current");
    });
    target.querySelector("a[href]")?.focus({ preventScroll: true });
  }

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes;
    const offsetBottom = headerMobile.getBoundingClientRect().bottom;
    const viewportBottom = window.visualViewport ? window.visualViewport.height + window.visualViewport.offsetTop : window.innerHeight;
    const panelHeight = Math.max(0, viewportBottom - offsetBottom);

    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
  }

  destroy() {
    if (this.events.signal.aborted) return;
    if (this.open) this.closeMenu(false);
    this.events.abort();
    Object.values(this.sliders).forEach((slider) => slider.destroy?.(true, true));
  }
}
class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container",
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active",
    };

    this.headerSticky = false;

    if (!container) return;
    this.container = container;
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.activeIndex = -1;
    this.lastActiveIndex = -1;
    this.visited = false;
    this.timeoutEnter = null;
    this.timeoutLeave = null;
    this.attachEvents();
  }

  attachEvents = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.addEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.addEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };

  initDropdownSize = () => {
    this.container && this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
    this.container && this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
  };

  onMenuItemEnter = (evt, index) => {
    const { target } = evt;

    if (!target.classList.contains("m-menu__item--mega")) return;

    clearTimeout(this.timeoutLeave);
    this.activeIndex = target.dataset && Number(target.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky === "true";
    this.reInitSlider(target);

    this.container && this.visited
      ? this.container.classList.remove(this.classes.slideReveal)
      : this.container.classList.add(this.classes.slideReveal);

    this.visited = true;
    this.lastActiveIndex >= 0 &&
      this.activeIndex >= 0 &&
      (this.container && this.lastActiveIndex < this.activeIndex
        ? this.container.classList.add(this.classes.slideFromRight)
        : this.lastActiveIndex > this.activeIndex && this.container.classList.remove(this.classes.slideFromRight));

    this.getElementBoundingRect(target).then((rect) => {
      if (rect) {
        this.container && this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container && this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex !== Number(target.dataset.index)) return;
        this.container && this.container.classList.add(this.classes.active);
        target.closest(".m-menu__item").classList.add("m-menu__item--active");
        // document.documentElement.classList.add("prevent-scroll");
      }, 120);
    });
  };

  onMenuItemLeave = (evt, index) => {
    this.activeIndex = -1;
    this.lastActiveIndex = index;
    evt.target.closest(".m-menu__item").classList.remove("m-menu__item--active");
    // document.documentElement.classList.remove("prevent-scroll");

    this.timeoutLeave = setTimeout(() => {
      if (this.activeIndex === -1 || this.activeIndex < 0) {
        this.visited = false;
      }
      this.resetMegaMenu(evt.target);
    }, 80);
  };

  reInitSlider = (menuItem) => {
    const swiper = menuItem.querySelector(this.selectors.swiper);
    if (!swiper) return;
    const itemIndex = menuItem.dataset.index;
    const slider = MinimogTheme && MinimogTheme.headerSliders[itemIndex];
    slider && slider.update();
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        top: rect.top,
      };
    }
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;

    clearTimeout(this.timeoutEnter);
    this.container &&
      this.container.classList.remove(
        this.classes.active,
        this.classes.slideFromRight,
        this.classes.slideReveal,
        "sf-header--bg-black",
        "sf-header--bg-white"
      );
  };

  windowWidth = () => {
    return window.innerWidth;
  };
  windowHeight = () => {
    return window.innerHeight;
  };

  destroy = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.removeEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.removeEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };
}
